
<section #title>

    <div class="title" [style.background-position]="'center ' + ((1 - offset) * 80 + 50) + '%'" [class.animate]="animate">
        <h2 class="for-sreader">{{ content[language].menu.gallery }}</h2>
        <div class="container d-flex column align-center justify-center">
            <h2 class="f-upper f-light f-right">{{ content[language].menu.gallery }}</h2>
            <h3 class="f-upper f-light f-right" [innerHTML]="content[language].gallery.title"></h3>
            <div class="arrows">
                <div></div>
                <div></div>
            </div>
        </div>
    </div>

    <owl-carousel-o #items
        class="gallery"
        [options]="gallery"
        (changed)="translated($event)"
        [style.top]="((1 - offset) * 20) + 'rem'">
        <ng-template carouselSlide *ngFor="let item of content[language].gallery.images">
            <div class="legend f-upper f-light d-flex f-right align-center justify-center" [innerHTML]="item.legend"></div>
            <div class="image">
                <img src="assets/content/{{ item.image }}" alt="{{ item.legend }}">
                <small>{{ language == 'pt' ? 'Perspectiva meramente ilustrativa' : 'Illustrative perspective' }}</small>
                <svg class="progress-ring" width="3.5rem" height="3.5rem">
                    <circle class="progress-ring__circle" stroke="white" stroke-width="0.6rem" fill="transparent" r="1.45rem" cx="1.75rem" cy="1.75rem"
                        stroke-dasharray="calc(1.45rem * 2 * 3.141592653589793)"
                        [attr.stroke-dashoffset]="'calc((1.45rem * 2 * 3.141592653589793) - ' + percent + ' / 100 * calc(1.45rem * 2 * 3.141592653589793))'" />
                </svg>
                <div class="progress-control" [class.stopped]="! controlIt" (click)="control()"></div>
            </div>
        </ng-template>
    </owl-carousel-o>

    <div class="gallery-counter f-light f-center" [style.transform]="'translate(0, ' + ((1 - offset) * 20) + 'rem)'">
        {{ slidePosition }} / {{ content[language].gallery.images.length }}
    </div>

</section>
